// extracted by mini-css-extract-plugin
module.exports = {"container":"Sensor_container__QJoY8","name":"Sensor_name__3oo9s","external":"Sensor_external__26np3","binIcon":"Sensor_binIcon__OTgZ9"};